import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, InputRef } from 'antd';

interface IFormProps extends FormComponentProps {
  onSubmit: (values: ICreateContactFormValues) => any;
}
interface IFormState {}

export interface ICreateContactFormValues {
  name: string;
  email: string;
  phone?: string;
}

const CreateContactForm: React.FC<IFormProps> = (props: IFormProps) => {
  const nameInputRef = React.useRef<InputRef>(null);
  const { form, onSubmit } = props;

  const { getFieldDecorator } = form;

  React.useEffect(() => {
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, values: ICreateContactFormValues) => {
      if (!err) {
        onSubmit(values);
      }
    });
  };

  const validateEmail = (
    rule: any,
    value: any,
    callback: (arg0?: string) => void,
  ) => {
    const valid = /.+@.+\..+/.test(form.getFieldValue('email'));

    if (!valid) {
      callback('Por favor, utiliza un correo electrónico válido');
    } else {
      callback();
    }
  };

  const validatePhone = (
    rule: any,
    value: any,
    callback: (arg0?: string) => void,
  ) => {
    const phone = form.getFieldValue('phone');

    if (!phone || /\s/.test(phone)) {
      callback();
    }

    const valid = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(
      form.getFieldValue('phone'),
    );

    if (!valid) {
      callback('Por favor, utiliza un número de teléfono válido');
    } else {
      callback();
    }
  };

  return (
    <Form layout={'vertical'} onSubmit={handleSubmit}>
      <Form.Item label={'Nombre'} required>
        {getFieldDecorator('name', {
          rules: [
            {
              required: true,
              message: 'Por favor, introduce un nombre',
            },
            {
              whitespace: true,
              message:
                'El nombre no puede incluir únicamente espacios en blanco',
            },
          ],
        })(
          <Input
            ref={nameInputRef}
            type={'text'}
            placeholder={'Introduzca un nombre'}
          />,
        )}
      </Form.Item>
      <Form.Item label={'Correo electrónico'} required>
        {getFieldDecorator('email', {
          rules: [
            {
              required: true,
              message: 'Por favor, introduzca un correo electrónico',
            },
            {
              whitespace: true,
              message:
                'El correo electrónico no puede incluir únicamente espacios en blanco',
            },
            {
              validator: validateEmail,
            },
          ],
        })(
          <Input
            type={'email'}
            placeholder={'Introduzca un correo electrónico'}
          />,
        )}
      </Form.Item>
      <Form.Item label={'Teléfono'} required={false}>
        {getFieldDecorator('phone', {
          rules: [
            {
              required: false,
            },
            {
              whitespace: true,
              message:
                'El número de teléfono no puede incluir únicamente espacios en blanco',
            },
            {
              // @ts-ignore
              type: 'string',
              validator: validatePhone,
            },
          ],
        })(
          <Input
            type={'text'}
            placeholder={'Introduzca un número de teléfono'}
          />,
        )}
      </Form.Item>
      <Form.Item>
        <Button
          className={'login-form-button'}
          type="primary"
          htmlType="submit"
        >
          Crear contacto
        </Button>
      </Form.Item>
    </Form>
  );
};
//
// class CreateContactForm extends React.Component<IFormProps, IFormState> {
//   private nameInputRef;
//
//   constructor(props) {
//     super(props);
//
//     this.nameInputRef = React.createRef();
//   }
//
//   componentDidMount() {
//     this.nameInputRef?.current?.focus?.();
//   }
//
//   handleSubmit = (e) => {
//     e.preventDefault();
//     this.props.form.validateFields(
//       async (err, values: ICreateContactFormValues) => {
//         if (!err) {
//           this.props.onSubmit(values);
//         }
//       },
//     );
//   };
//
//   validateEmail = async (
//     rule: any,
//     value: any,
//     callback: (arg0?: string) => void,
//   ) => {
//     const { form } = this.props;
//
//     const valid = /.+@.+\..+/.test(form.getFieldValue('email'));
//
//     if (!valid) {
//       callback('Por favor, utiliza un correo electrónico válido');
//     } else {
//       callback();
//     }
//   };
//
//   validatePhone = (
//     rule: any,
//     value: any,
//     callback: (arg0?: string) => void,
//   ) => {
//     const { form } = this.props;
//
//     const phone = form.getFieldValue('phone');
//
//     if (!phone || /\s/.test(phone)) {
//       callback();
//     }
//
//     const valid = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(
//       form.getFieldValue('phone'),
//     );
//
//     if (!valid) {
//       callback('Por favor, utiliza un número de teléfono válido');
//     } else {
//       callback();
//     }
//   };
//
//   render(): React.ReactNode {
//     const { getFieldDecorator } = this.props.form;
//     return (
//       <Form layout={'vertical'} onSubmit={this.handleSubmit}>
//         <Form.Item label={'Nombre'} required>
//           {getFieldDecorator('name', {
//             rules: [
//               {
//                 required: true,
//                 message: 'Por favor, introduce un nombre',
//               },
//               {
//                 whitespace: true,
//                 message:
//                   'El nombre no puede incluir únicamente espacios en blanco',
//               },
//             ],
//           })(
//             <Input
//               ref={this.nameInputRef}
//               type={'text'}
//               placeholder={'Introduzca un nombre'}
//             />,
//           )}
//         </Form.Item>
//         <Form.Item label={'Correo electrónico'} required>
//           {getFieldDecorator('email', {
//             rules: [
//               {
//                 required: true,
//                 message: 'Por favor, introduzca un correo electrónico',
//               },
//               {
//                 whitespace: true,
//                 message:
//                   'El correo electrónico no puede incluir únicamente espacios en blanco',
//               },
//               {
//                 validator: this.validateEmail,
//               },
//             ],
//           })(
//             <Input
//               type={'email'}
//               placeholder={'Introduzca un correo electrónico'}
//             />,
//           )}
//         </Form.Item>
//         <Form.Item label={'Teléfono'} required={false}>
//           {getFieldDecorator('phone', {
//             rules: [
//               {
//                 required: false,
//               },
//               {
//                 whitespace: true,
//                 message:
//                   'El número de teléfono no puede incluir únicamente espacios en blanco',
//               },
//               {
//                 // @ts-ignore
//                 type: 'string',
//                 validator: this.validatePhone,
//               },
//             ],
//           })(
//             <Input
//               type={'text'}
//               placeholder={'Introduzca un número de teléfono'}
//             />,
//           )}
//         </Form.Item>
//         <Form.Item>
//           <Button
//             className={'login-form-button'}
//             type="primary"
//             htmlType="submit"
//           >
//             Crear contacto
//           </Button>
//         </Form.Item>
//       </Form>
//     );
//   }
// }

const MyCreateContactForm = Form.create<IFormProps>()(CreateContactForm);

export default MyCreateContactForm;
